import { Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import { AppType } from "src/types/apps";

import TypeTitle from "./TypeTitle";
// ----------------------------------------------------------------------

export default function TypeNameApp() {
	const { data: apps } = useQuery<AppType[]>({ queryKey: ["apps"], initialData: [] });
	const { data: appIdSelected } = useQuery<string>({
		queryKey: ["apps", "selected"],
		initialData: ""
	});

	const { translate } = useLocales();

	const appSelected = appIdSelected !== "" ? apps.find((i) => i.id === appIdSelected) : apps[0];

	return (
		<>
			<Stack justifyContent='center' sx={{ ml: { xs: 1, sm: 1.5 } }}>
				<TypeTitle />
				<Typography color='text.primary' noWrap sx={{ mt: 1 }} variant='subtitle2'>
					{translate(appSelected?.name || "nav_app_section.app_not_selected")}
				</Typography>
			</Stack>
			<Iconify icon='iconamoon:arrow-down-2' ml='auto' width={20} />
		</>
	);
}
